import React, { Component } from 'react';
import { Big3Common, bootstrap } from '../../../js/IncludeManager'
/* 개발담당:양유빈
 * 화면기능:상품자동입력
 * 세부설명:
*/

export class DescInput extends Component {
    static displayName = DescInput.name;

    constructor(props) {
        super(props);
        this.state = {
            No: null,
            Dtl_Content: "",
            Modify: false
        };
        this.handle_Change = this.handle_Change.bind(this);
        this.handleSave_Click = this.handleSave_Click.bind(this);
        this.handleClose_Click = this.handleClose_Click.bind(this);
        this.refDescInput = React.createRef();
       
    }
    //초기화
    componentDidMount() {
    }
    componentWillUnmount() {
    } 
    //자동입력 데이터 조회
    async CallDescInputData(no) {
        try {
            
            let Dtl_Content = "";
            let Data = await Big3Common.Get(`api/Goods/GoodsReg/GetGoodsContentDtl/${no}`);            
            if (Data.codeName === Big3Common.ResultCode.Success) {
                let DataList = JSON.parse(Data.dataTable);
                if (DataList.length > 0) 
                {
                    Dtl_Content = DataList[0].dtl_content;
                    this.setState({ Dtl_Content: Dtl_Content });
                }
            }
            this.setState({ No: no, Dtl_Content: Dtl_Content });
        }
        catch (e) {
            console.log("CallDescInputData: ", e)
        }    
    }
    handle_Change = (event) => {
        const Dtl_Content = event.target.value;
        this.setState({
            Dtl_Content: Dtl_Content,
            Modify: true
        });
        event.preventDefault();
    }
    //자동입력 값 저장 및 반환
    handleSave_Click = async (event) => {
        const Dtl_Content = this.state.Dtl_Content;
        this.props.Callback(Dtl_Content);
        if (this.state.Modify === true) {
            try {
                await Big3Common.Post("api/Goods/GoodsReg/RegisterGoodsDtlContent",
                {
                        no: this.state.No,
                        dtl_content: Dtl_Content
                });                
            }
            catch (e) {
                console.log("handleSearch_Click: ", e);
            }
        }
        this.handleClose_Click(event);
        
    }
    handleClose_Click(event) {
        let modalID = this.props.id;
        var modalEl = document.getElementById(modalID);
        var thismodal = bootstrap.Modal.getInstance(modalEl);
        thismodal.hide();
        event.preventDefault();
    }
    render() {
        return (
            <div className="modal fade" tabIndex="-1" style={{ zIndex: this.props.zIndex === undefined ? 2000 : this.props.zIndex }} id={this.props.id} data-bs-keyboard="false"
                data-bs-backdrop={this.props.backdrop === undefined ? "static" : this.props.backdrop}
                ref={this.refTimmer}
            >
                <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                    <div className="modal-content EmpDtl_modal">
                        <div className="modal-header EmpDtl_modal_header">
                            <div className="modal-title">자동입력{this.state.No}</div>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            <div className="textarea">
                                <textarea
                                    placeholder="상품 상세설명을 입력해주세요."
                                    id="Dtl_Content"
                                    onChange={this.handle_Change}
                                    value={this.state.Dtl_Content}
                                />
                            </div>
                        </div>
                        <div className="modal-footer notice_modal_footer">
                            <button type="button" className="a_btn a_btn1" onClick={this.handleClose_Click}>취소</button>
                            <button type="button" className="a_btn a_btn2" onClick={this.handleSave_Click }>적용</button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
